import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import './assets/scss/styles.scss';
import { RouterProvider } from 'react-router-dom';
import { browserRouter } from './routes/allRoutes';
import { QueryClient, QueryClientProvider } from 'react-query';
import Amplify from 'aws-amplify';
import { awsConfig } from './config/awsConfig';
import MlxBlockUI from './components/common/MlxBlockUI/MlxBlockUI';
import { JTranslationProvider } from './context/JTranslationProvider';
import { APIOptions, PrimeReactProvider } from 'primereact/api';
import 'react-phone-number-input/style.css';

Amplify.configure(awsConfig);
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const primeReactOptions: APIOptions = {
    hideOverlaysOnDocumentScrolling: true,
    zIndex: {
        modal: 2100, // dialog, sidebar
        overlay: 2000, // dropdown, overlaypanel
        menu: 2000, // overlay menus
        tooltip: 2100, // tooltip
        toast: 2200, // toast
    },
    autoZIndex: false,
};

root.render(
    <PrimeReactProvider value={primeReactOptions}>
        <JTranslationProvider apiKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY ?? ''}>
            <QueryClientProvider client={queryClient}>
                <RouterProvider router={browserRouter} fallbackElement={<MlxBlockUI isLoading={true}></MlxBlockUI>} />
            </QueryClientProvider>
        </JTranslationProvider>
    </PrimeReactProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
